<template>
    <div class="modal fade bd-example-modal-lg" id="modalAllocationSelect" tabindex="-1" role="dialog" aria-labelledby="allocationSelectLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">                    
                    <h3>Select an allocation</h3>    
                    <button class="btn btn-lg btn-default float-end" type="button" data-bs-dismiss="modal"><i class="fas fa-lg fa-times" aria-hidden="true"></i></button>                                
                </div>
                <div class="modal-body">
                    <div class="form-row">			
                        <div class="col input-group form-label-group">
                            <input type="text" class="form-control" v-model="search" placeholder="Type a fund name to begin searching...">
                            <label>Type a fund name to begin searching...</label>
							<button type="button" :disabled="search == ''" v-on:click="search = ''" class="btn btn-danger"><i class="fas fa-times"></i> Clear</button>						    
                        </div>			
                    </div>                                        
                    <div class="card mb-3">
                        <ul class="list-group list-group-flush">
                            <li :key="k" class="list-group-item" :class="{'bg-success text-white': a.ALLOCATION_CODE == $parent.donorData.RECEIPT_DATA.allocations[$parent.currentAllocation].allocationCode}" v-for="(a, k) in paginatedData">
                                <span v-html="$options.filters.highlight(a.NCSU_LONG_NAME, search.toLowerCase())"></span>                            
                                <button v-if="a.ALLOCATION_CODE != $parent.donorData.RECEIPT_DATA.allocations[$parent.currentAllocation].allocationCode" class="float-end btn btn-sm btn-success" v-on:click="setAllocation(a)" type="button"><i class="fas fa-mouse-pointer"></i> Select</button>
                                <button v-if="a.ALLOCATION_CODE == $parent.donorData.RECEIPT_DATA.allocations[$parent.currentAllocation].allocationCode" class="float-end btn btn-sm btn-success" disabled type="button"><i class="fas fa-check"></i> Selected</button>
                            </li>                                
                        </ul>
                        <div class="card-footer">
                            <div class="row">
                                <div class="col-2">
                                    <button class="btn btn-primary" type="button" :disabled="pageNumber == 0" v-on:click="prevPage()"><i class="fas fa-chevron-left"></i> Back</button>
                                </div>
                                <div class="col-8" style="text-align: center">
                                    <span v-if="pageCount">
                                        page {{pageNumber + 1}} of {{pageCount}}
                                    </span>
                                </div>
                                <div class="col">
                                    <button class="float-end btn btn-primary" type="button" :disabled="pageNumber == pageCount - 1 || !pageCount" v-on:click="nextPage()">Next <i class="fas fa-chevron-right"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">                    
                    <button type="button" class="float-end btn btn-secondary" data-bs-dismiss="modal"><i class="fas fa-times"></i> Close</button>                
                </div> 
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap';
export default {
    data() {
        return {
            search: '',
		    size: 10,
            pageNumber: 0,
            modal: null
        }
    },
    methods: {
        nextPage: function() {
            if (this.pageNumber < this.pageCount) {
                this.pageNumber++;
            }
        },
        prevPage: function() {
            if (this.pageNumber > 0) {
                this.pageNumber--;
            }
        },
        setAllocation: function(allocation) {
            this.$parent.donorData.RECEIPT_DATA.allocations[this.$parent.currentAllocation].allocationCode = allocation.ALLOCATION_CODE;
            this.$parent.donorData.RECEIPT_DATA.allocations[this.$parent.currentAllocation].account2 = allocation.ACCOUNT_2;
            this.$parent.donorData.RECEIPT_DATA.allocations[this.$parent.currentAllocation].account2Description = allocation.FOUNDATION_NAME;
            this.$parent.donorData.RECEIPT_DATA.allocations[this.$parent.currentAllocation].agency = allocation.AGENCY;
            this.$parent.donorData.RECEIPT_DATA.allocations[this.$parent.currentAllocation].agencyDescription = allocation.AGENCY_DESC;
            this.$parent.donorData.RECEIPT_DATA.allocations[this.$parent.currentAllocation].federalId = allocation.FEDERAL_ID;
            this.$parent.donorData.RECEIPT_DATA.allocations[this.$parent.currentAllocation].allocationName = allocation.LONG_NAME;
            this.$parent.donorData.RECEIPT_DATA.allocations[this.$parent.currentAllocation].displayAgency = allocation.DISPLAY_AGENCY;
            
            this.search = '';
            this.pageNumber = 0;  
            this.modal.hide();                      
        }        
    },
    computed: {
        filteredAllocations: function() {
            return this.$parent.allAllocations.filter(a => {
                return a.NCSU_LONG_NAME.toLowerCase().includes(this.search.toLowerCase());
            });
        },
        pageCount: function() {
            let l = this.filteredAllocations.length;
            let s = this.size;
            var c = Math.floor(l/s);
            if (l % s > 0) {
                c++;
            }					
            return c;
        },
        paginatedData: function() {            
            if (this.pageNumber > this.pageCount) {                
                this.pageNumber = 0;
            }
            const start = this.pageNumber * this.size;            
            const end = start + this.size;
            return this.filteredAllocations.slice(start, end);
        }
    },
    mounted: function() {
        this.modal = new Modal(document.getElementById('modalAllocationSelect'));   
    }
}
</script>
<style scoped>
.modal-footer {
    display: block;
}

.input-group > input {    
    border-bottom-left-radius: 0;
}
.input-group > button {    
    border-bottom-right-radius: 0;
}

.card {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;    
}

.list-group, .list-group:first-child {border-top: none;}
</style>